// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"2d97e7f6","320":"ac952db2","443":"12db4835","563":"26a9b4f3","577":"757729a8","666":"3d5407f3","740":"97e08526","755":"aead3503","777":"0c2e5fdd","780":"9aefc66e","865":"9598407b"}[chunkId] + ".chunk.js";
};